/**
 * The unit a STILL-BLANK line opens on.
 *
 * RULED 2026-09-24 (Copeland, `docs/phases/PHASE_purchase-uom-default.md`),
 * built 2026-10-09: a blank line defaults to the item's **purchase** unit
 * wherever Business Central holds one that differs from base, and to **base**
 * where it does not — the common case, and no change there. This reverses only
 * the *default* half of the 2026-08-31 ruling (item 3); which items get a
 * toggle, the toggle itself and the review screen are untouched.
 *
 * Precedence is unchanged and lives in `Entry.tsx`: a draft's own choice, then
 * whatever is already staged, and only then this default. A line already
 * counted keeps the unit it was entered in by that precedence, not by a guard.
 *
 * `unit_options` carries exactly what is needed — base first with `is_base`,
 * the purchase unit second when it differs — so this chooses an entry, it
 * invents no data. If more than two entries ever arrive, the first non-base one
 * wins (decision rule 3, 2026-10-09).
 */
import type { CountListItem } from "../api/types";

/** The item's non-base counting unit, or null where purchase == base. */
export function purchaseUnit(item: CountListItem): string | null {
  return item.unit_options?.find((option) => !option.is_base)?.code ?? null;
}

/** What the unit select shows for a still-blank line: purchase where it differs, else base. */
export function defaultUnit(item: CountListItem): string | null {
  return purchaseUnit(item) ?? item.base_unit_of_measure;
}
